import { get } from 'lodash';
import { validateLink } from 'src/constrains/LinkLibrary/tools';
import { mediaTypeCheck } from 'src/tools/helper';
import { getI18nFromGeneral } from 'src/tools/tools';
import { MediaType } from 'src/types/common/common';
import {
  //EBackgroundType,
  ELayerType,
  // EModuleWidth,
  // EnumCarouselOptions,
  EnumModuleType,
  // EOverflowOption,
  // EnumScrollType,
  // EnumSeoTag,
  // EOverflowOption,
  // EPositionOption,
  // EResponsiveCarouselModuleSwitcherType,
  EResponsiveContentPageToShow,
  //EResponsivePosterGap,
  EResponsivePosterType,
  EResponsiveProductToShow,
  //EOverflowOption,
} from 'src/types/common/module';
import { EPreviewSize } from 'src/types/common/SalesChannel';

export const handleError = (errs) => {
  return {
    hasError: (errs || []).length > 0,
    errors: errs,
  };
};

const responsivePosterTypeDict = {
  [EResponsivePosterType.ONE]: 1,
  [EResponsivePosterType.FIVE]: 5,
  [EResponsivePosterType.FOUR]: 4,
  [EResponsivePosterType.SIX]: 6,
  [EResponsivePosterType.THREE]: 3,
  [EResponsivePosterType.TWO_1_1]: 2,
  [EResponsivePosterType.TWO_1_2]: 2,
  [EResponsivePosterType.TWO_2_1]: 2,
};

const responsiveProductTypeDict = {
  [EResponsiveProductToShow.One]: 1,
  [EResponsiveProductToShow.Two]: 2,
  [EResponsiveProductToShow.TwoLandscape]: 2,
  [EResponsiveProductToShow.TwoPortrait]: 2,
  [EResponsiveProductToShow.Three]: 3,
  [EResponsiveProductToShow.Four]: 4,
  [EResponsiveProductToShow.Five]: 5,
  [EResponsiveProductToShow.Six]: 6,
};

const contentPageNumberErr = {
  1: 999936,
  2: 999937,
  3: 999938,
  4: 999941,
  5: 999940,
  6: 999939,
};

const productNumberErr = {
  1: 999949,
  2: 999950,
  3: 999951,
  4: 999954,
  5: 999953,
  6: 999952,
};

const productExactNumberErr = {
  1: 999942,
  2: 999943,
  3: 999944,
  4: 999947,
  5: 999946,
  6: 999945,
};

const contentPageExactNumberErr = {
  1: 999955,
  2: 999956,
  3: 999957,
  4: 999961,
  5: 999960,
  6: 999959,
};

const responsiveContentPageTypeDict = {
  [EResponsiveContentPageToShow.One]: 1,
  [EResponsiveContentPageToShow.Two]: 2,
  [EResponsiveContentPageToShow.TwoLandscape]: 2,
  [EResponsiveContentPageToShow.TwoPortrait]: 2,
  [EResponsiveContentPageToShow.Three]: 3,
  [EResponsiveContentPageToShow.Four]: 4,
  [EResponsiveContentPageToShow.Five]: 5,
  [EResponsiveContentPageToShow.Six]: 6,
};

const handleBreakpointIsWide = (extraProps) => {
  const breakpoint = get(extraProps, 'breakpoint') || EPreviewSize.WIDE;
  const isWide = breakpoint === EPreviewSize.WIDE;
  return isWide;
};

const handleOnMergeResult = (results) => {
  return results.reduce(
    (pre, now) => {
      const { hasError, errors } = now || {};

      if (hasError) {
        return {
          hasError,
          errors: [...(errors || []), ...(pre.errors || [])],
        };
      } else {
        return pre;
      }
    },
    { hasError: false, errors: [] },
  );
};

const validateEachTabCount = (
  requiredBase = 1,
  data = [],
  emptyCode: number | string,
  isProduct: boolean,
  greaterOnly?: boolean,
) => {
  //console.log()

  const _code = {
    1: isProduct ? '999975' : '999971',
    2: isProduct ? '104326' : '104334',
    3: isProduct ? '104327' : '104335',
    4: isProduct ? '999974' : '999970',
    5: isProduct ? '999973' : '999969',
    6: isProduct ? '999972' : '999968',
  };

  if (data.length === 0) {
    return handleError([
      getI18nFromGeneral(`general.moduleListError.${emptyCode || 104337}`),
    ]);
  }
  if (greaterOnly) {
    if (data.length !== 0 && data.length < requiredBase) {
      const code = _code[requiredBase];
      return handleError([
        getI18nFromGeneral(`general.moduleListError.${code}`),
      ]);
    }
  } else {
    if (data.length !== 0 && data.length % requiredBase !== 0) {
      const code = _code[requiredBase];
      return handleError([
        getI18nFromGeneral(`general.moduleListError.${code}`),
      ]);
    }
  }
};

const validateContentImgList = () => {
  const checkCountOfContentPages = (contentPages) => {
    if (contentPages?.length < 1) {
      return handleError([
        getI18nFromGeneral(`general.moduleListError.999990`),
      ]);
    }
  };
  const checkContentPageHasSelectedError = (contentPage) => {
    const uuid = get(contentPage, 'uuid');
    if (!uuid) {
      return handleError([
        getI18nFromGeneral(`general.moduleListError.999978`),
      ]);
    }
  };

  const checkContentPageExistingError = (contentPage, contentPages) => {
    const checkPage = checkContentPageHasSelectedError(contentPage);
    if (get(checkPage, 'hasError')) {
      return checkPage;
    }
    const uuid = get(contentPage, 'uuid');
    const find = (contentPages || []).find((i) => i.uuid === uuid);
    if (!find) {
      return { hasError: false };
      return handleError([
        getI18nFromGeneral(`general.moduleListError.999978`),
      ]);
    }
  };

  const checkContentPageImageError = (image) => {
    const uuid = get(image, 'uuid');
    if (!uuid) {
      return handleError([
        getI18nFromGeneral(`general.moduleListError.999978`),
      ]);
    }
  };

  const checkContentPageSummaryError = (summary) => {
    if (!summary) {
      return handleError([
        getI18nFromGeneral(`general.moduleListError.999978`),
      ]);
    }
  };

  const checkSubtitleError = (subtitle, subTitleRequired?) => {
    if (!subtitle) {
      return handleError([
        getI18nFromGeneral(`general.moduleListError.999978`),
      ]);
    }
  };

  const checkEachContentPageError = (contentPage, contentPages) => {
    const summary = get(contentPage, 'summary');
    const subtitle = get(contentPage, 'subtitle');
    const subTitleRequired = get(contentPage, 'subTitleRequired');
    const image = get(contentPage, 'image');
    const selectError = checkContentPageHasSelectedError(
      get(contentPage, 'contentPage'),
    );
    const selectedExistingError = checkContentPageExistingError(
      get(contentPage, 'contentPage'),
      contentPages,
    );
    const imageError = checkContentPageImageError(image);
    const summaryError = checkContentPageSummaryError(summary);
    const subtitleError = checkSubtitleError(subtitle, subTitleRequired);

    return {
      hasError:
        get(selectError, 'hasError') ||
        get(selectedExistingError, 'hasError') ||
        get(imageError, 'hasError') ||
        get(summaryError, 'hasError') ||
        get(subtitleError, 'hasError'),
    };
  };

  const checkAll = (contentPages, extraProps) => {
    const { contentPages: allContentPages } = extraProps;
    let eachContentError = false;
    // const contentPages = get(data, 'contentPages');
    contentPages?.forEach((c) => {
      const hasError = get(
        checkEachContentPageError(c, allContentPages),
        'hasError',
      );
      if (!eachContentError) {
        eachContentError = hasError;
      }
    });
    const countHasError = checkCountOfContentPages(contentPages);

    return {
      hasError: get(countHasError, 'hasError') || eachContentError,
    };
  };
  return {
    checkAll,
    checkEachContentPageError,
    checkContentPageHasSelectedError,
    checkContentPageExistingError,
    checkContentPageImageError,
    checkContentPageSummaryError,
    checkSubtitleError,
  };
};

const validatePosterAndImages = (data, extraProps?) => {
  //images/poster
  const { isPoster, breakpoint } = extraProps || {};
  const { imageLink, image, name, layers } = data;

  const { checkAll: checkCarouselSetting } = validateCarouselSetting();
  const { checkAll: checkPosterCarouselSetting } =
    validatePosterCarouselSetting();

  const errorCarouselSetting = isPoster
    ? checkPosterCarouselSetting(
        {
          imageLink,
          image,
          name,
        },
        {
          breakpoint,
        },
      )
    : checkCarouselSetting(
        {
          imageLink,
          image,
          name,
        },
        {
          breakpoint,
        },
      );
  const settingHasError = get(errorCarouselSetting, 'hasError');
  let layerHasError = false;
  (layers || []).forEach((now) => {
    const error = validateLayerType(now, breakpoint);
    const hasError = get(error, 'hasError');
    if (hasError && !layerHasError) {
      layerHasError = true;
    }
  });

  return {
    hasError: layerHasError || settingHasError,
  };
};

const validateCarouselSetting = () => {
  const checkName = (name, otherProps) => {
    if (!name) {
      return handleError([
        getI18nFromGeneral('general.moduleListError.999965'),
      ]);
    }
  };
  const checkImage = (image, otherProps) => {
    const imageUuid = get(image, 'uuid');

    if (!imageUuid) {
      return handleError([
        getI18nFromGeneral('general.moduleListError.999964'),
      ]);
    }
  };
  const checkImageLink = (imageLink, otherProps) => {
    const linkType = get(imageLink, 'linkType');

    if (!linkType) {
      return handleError([
        getI18nFromGeneral('general.moduleListError.999963'),
      ]);
    }
  };
  const checkAll = (data, extraProps) => {
    const nameError = checkName(get(data, 'name'), extraProps);
    const imageError = checkImage(get(data, 'image'), extraProps);
    const type = mediaTypeCheck(get(data, 'image'));
    if (type === MediaType.Image) {
      const imageLinkError = checkImageLink(get(data, 'imageLink'), extraProps);
      return {
        hasError:
          get(nameError, 'hasError') ||
          get(imageError, 'hasError') ||
          get(imageLinkError, 'hasError'),
      };
    }
    return {
      hasError: get(nameError, 'hasError') || get(imageError, 'hasError'),
    };
  };
  return { checkName, checkImage, checkImageLink, checkAll };
};

const validatePosterCarouselSetting = () => {
  const checkName = (name, otherProps) => {
    if (!name) {
      return handleError([
        getI18nFromGeneral('general.moduleListError.999965'),
      ]);
    }
  };

  const checkImage = (image, otherProps) => {
    //const type = mediaTypeCheck(image);
    // const imageUuid = get(image, 'uuid');
    // if (!imageUuid && handleBreakpointIsWide(otherProps)) {
    //   return handleError([
    //     getI18nFromGeneral('general.moduleListError.999964'),
    //   ]);
    // }
    return { hasError: false };
    // if (type === MediaType.Image) {
    //   const imageUuid = get(image, 'uuid');
    //   if (!imageUuid && handleBreakpointIsWide(otherProps)) {
    //     return handleError([
    //       getI18nFromGeneral('general.moduleListError.999964'),
    //     ]);
    //   }
    // }
  };

  const checkImageLink = (imageLink, otherProps) => {
    const linkType = get(imageLink, 'linkType');
    //const type = mediaTypeCheck(image);
    if (!linkType) {
      return handleError([
        getI18nFromGeneral('general.moduleListError.999963'),
      ]);
    }
  };

  const checkImageAndLink = (image, imageLink, otherProps) => {
    const type = mediaTypeCheck(image);

    if (type === MediaType.Image) {
      const imageError = checkImage(image, otherProps);
      const linkError = checkImageLink(imageLink, otherProps);
      return {
        hasError: get(imageError, 'hasError') || get(linkError, 'hasError'),
      };
    }
    // if (type === MediaType.Video) {
    const imageError = checkImage(image, otherProps);
    return {
      hasError: get(imageError, 'hasError'),
    };
    // }
  };

  const checkAll = (data, extraProps) => {
    const nameError = checkName(get(data, 'name'), extraProps);
    const imageAndLinkError = checkImageAndLink(
      get(data, 'image'),
      get(data, 'imageLink'),
      extraProps,
    );
    return {
      hasError:
        get(imageAndLinkError, 'hasError') || get(nameError, 'hasError'),
    };
  };
  return { checkName, checkImage, checkImageLink, checkAll };
};

const validateButtonLayer = () => {
  const checkButtonLayerLink = (linkModule, extraProps) => {
    const { result, code } = validateLink(linkModule) || {};
    if (!result) {
      return handleError([
        getI18nFromGeneral(`general.moduleListError.${code}`),
      ]);
    }
  };
  const checkButtonLayerButtonText = (buttonText, extraProps) => {
    if (!buttonText) {
      return handleError([
        getI18nFromGeneral(`general.moduleListError.104310`),
      ]);
    }
  };
  const checkButtonLayerButtonThemeUuid = (buttonThemeUuid, extraProps) => {
    if (!buttonThemeUuid) {
      return handleError([
        getI18nFromGeneral(`general.moduleListError.104310`),
      ]);
    }
  };
  const checkAll = (layer, extraProps) => {
    const buttonText = get(layer, 'buttonText');
    const buttonThemeUuid = get(layer, 'buttonThemeUuid');
    const linkModule = get(layer, 'linkModule');
    const linkError = checkButtonLayerLink(linkModule, extraProps);
    const buttonTextError = checkButtonLayerButtonText(buttonText, extraProps);
    const buttonThemeUuidError = checkButtonLayerButtonThemeUuid(
      buttonThemeUuid,
      extraProps,
    );
    return {
      hasError:
        get(linkError, 'hasError') ||
        get(buttonTextError, 'hasError') ||
        get(buttonThemeUuidError, 'hasError'),
    };
  };
  return {
    checkAll,
    checkButtonLayerLink,
    checkButtonLayerButtonText,
    checkButtonLayerButtonThemeUuid,
  };
};

const validateImageLayer = () => {
  const checkButtonLayerLink = (linkModule) => {
    const { result, code } = validateLink(linkModule) || {};
    if (!result) {
      return handleError([
        getI18nFromGeneral(`general.moduleListError.${code}`),
      ]);
    }
  };
  const checkButtonLayerImage = (image) => {
    const imageUuid = get(image, 'uuid');
    if (!imageUuid) {
      return handleError([
        getI18nFromGeneral(`general.moduleListError.104310`),
      ]);
    }
  };

  const checkAll = (layer) => {
    const image = get(layer, 'image');
    const linkModule = get(layer, 'linkModule');
    const linkError = checkButtonLayerLink(linkModule);
    const buttonTextError = checkButtonLayerImage(image);

    return {
      hasError: get(linkError, 'hasError') || get(buttonTextError, 'hasError'),
    };
  };
  return {
    checkAll,
    checkButtonLayerLink,
    checkButtonLayerImage,
  };
};

const validateLayerType = (layer, extraProps) => {
  //console.log('layerType', layerType);
  const layerType = get(layer, 'layerType');
  if (layerType === ELayerType.BUTTON) {
    const { checkAll } = validateButtonLayer();
    return checkAll(layer, extraProps);
  }
  if (layerType === ELayerType.IMAGE) {
    const { checkAll } = validateImageLayer();
    return checkAll(layer);
  }
  if (layerType === ELayerType.TEXT) {
  }
};

const validateIframeLink = () => {
  const checkIframeLink = (linkModule, extraProps) => {
    const { result, code } = validateLink(linkModule) || {};
    if (!result) {
      return handleError([
        getI18nFromGeneral(`general.moduleListError.${code}`),
      ]);
    }
  };
  return {
    checkIframeLink,
  };
};

const checkResponsiveSubscription = () => {
  const checkFields = (fields, extraProps) => {
    if ((fields || []).length < 1) {
      return handleError([
        getI18nFromGeneral('general.moduleListError.999976'),
      ]);
    }
    return {
      hasError: false,
    };
  };
  const checkTacs = (tacs, extraProps) => {
    const att = (tacs || []).reduce((pre, now) => {
      const { consentAttributes } = now || {};
      return [...pre, ...(consentAttributes || [])];
    }, []);
    if (att.length < 1 && handleBreakpointIsWide(extraProps)) {
      //999979
      return handleError([
        getI18nFromGeneral('general.moduleListError.999979'),
      ]);
    }
  };
  const checkLayoutOption = (layoutOption, extraProps) => {
    if (!layoutOption && handleBreakpointIsWide(extraProps)) {
      return handleError([
        getI18nFromGeneral('general.moduleListError.999993'),
      ]);
    }
  };
  const checkText = (text, extraProps) => {
    if (!text) {
      return handleError([
        getI18nFromGeneral('general.moduleListError.999999'),
      ]);
    }
  };
  const checkSubmitButtonText = (submitButtonText, extraProps) => {
    if (!submitButtonText && handleBreakpointIsWide(extraProps)) {
      return handleError([
        getI18nFromGeneral('general.moduleListError.999999'),
      ]);
    }
  };
  const checkModuleStyleBottomPadding = (bottomPadding) => {
    // const bottomPadding = get(moduleStyle, 'bottomPadding');
    if (!bottomPadding) {
      return handleError([
        getI18nFromGeneral('general.moduleListError.999978'),
      ]);
    }
  };
  const checkModuleStyleTopPadding = (topPadding) => {
    // const topPadding = get(moduleStyle, 'topPadding');
    // if (!topPadding) {
    //   return handleError([
    //     getI18nFromGeneral('general.moduleListError.999978'),
    //   ]);
    // }
  };
  const checkAll = (data, extraProps) => {
    const fieldsError = checkFields(get(data, 'fields'), extraProps);
    const tacsError = checkTacs(get(data, 'tacs'), extraProps);
    const layoutOptionError = checkLayoutOption(
      get(data, 'layoutOption'),
      extraProps,
    );
    const textError = checkText(get(data, 'text'), extraProps);
    const submitButtonTextError = checkSubmitButtonText(
      get(data, 'submitButtonText'),
      extraProps,
    );

    const topPaddingError = checkModuleStyleTopPadding(
      get(data, 'moduleStyle.topPadding'),
    );
    const bottomPaddingError = checkModuleStyleBottomPadding(
      get(data, 'moduleStyle.bottomPadding'),
    );
    return {
      hasError:
        get(fieldsError, 'hasError') ||
        get(tacsError, 'hasError') ||
        get(layoutOptionError, 'hasError') ||
        get(textError, 'hasError') ||
        get(submitButtonTextError, 'hasError') ||
        get(topPaddingError, 'hasError') ||
        get(bottomPaddingError, 'hasError'),
    };
  };
  return {
    checkFields,
    checkTacs,
    checkLayoutOption,
    checkText,
    checkSubmitButtonText,
    checkModuleStyleTopPadding,
    checkModuleStyleBottomPadding,
    checkAll,
  };
};

const checkResponsivePoster = () => {
  const checkPoster = (image, extraProps) => {
    return validatePosterAndImages(image, {
      ...(extraProps || {}),
      isPoster: true,
    });
  };
  const checkImages = (images, extraProps) => {
    let hasError = false;
    (images || []).forEach((i) => {
      const e = get(checkPoster(i, extraProps), 'hasError');

      if (!hasError) {
        hasError = e;
      }
    });
    return { hasError };
  };

  const checkAll = (data, extraProps) => {
    return checkImages(get(data, 'images') || [], extraProps);
  };
  return { checkAll, checkPoster, checkImages };
};

const checkResponsiveImageCarousel = () => {
  const checkImage = (image, extraProps) => {
    return validatePosterAndImages(image, {
      ...(extraProps || {}),
      isPoster: false,
    });
  };
  const checkImages = (images, extraProps) => {
    let hasError = false;
    (images || []).forEach((i) => {
      const e = get(checkImage(i, extraProps), 'hasError');

      if (!hasError) {
        hasError = e;
      }
    });

    return { hasError };
  };

  const checkAll = (data, extraProps) => {
    return checkImages(get(data, 'images') || [], extraProps);
  };
  return { checkAll, checkImage, checkImages };
};

const checkResponsiveProductCarousel = () => {
  const checkProductsCountError = (data) => {
    const products = get(data, 'products') || [];
    const numOfList = products.length;
    const productToShow = get(data, 'productToShow');
    const correctNumber = responsiveProductTypeDict[productToShow];
    if (numOfList >= correctNumber) {
    } else {
      const errCode = productNumberErr[correctNumber];
      return handleError([
        getI18nFromGeneral(`general.moduleListError.${errCode}`),
      ]);
    }
  };
  const checkTopSectionDisplayError = (data, extraProps) => {
    return checkProductsCountError(data);
  };

  const checkProductsError = (data, extraProps) => {
    return checkProductsCountError(data);
  };

  const checkAll = (data, extraProps) => {
    return checkProductsError(data, extraProps);
  };
  return {
    checkProductsCountError,
    checkTopSectionDisplayError,
    checkProductsError,
    checkAll,
  };
};

const checkResponsiveContentCarousel = () => {
  const checkPagesCountError = (data, extraProps) => {
    const contentPagesToShow = get(data, 'contentPagesToShow');
    const contentPages = get(data, 'contentPages');
    const numOfList = (contentPages || []).length;
    const correctNumber = responsiveContentPageTypeDict[contentPagesToShow];
    if (correctNumber > numOfList) {
      const errorCode = contentPageNumberErr[correctNumber];
      return handleError([
        getI18nFromGeneral(`general.moduleListError.${errorCode}`),
      ]);
    }
  };
  const checkTopSectionDisplayError = (data, extraProps) => {
    return checkPagesCountError(data, extraProps);
  };
  const checkEachContentPageError = (contentPage, extraProps) => {
    const { checkEachContentPageError: cP } = validateContentImgList();
    const contentPages = get(extraProps, 'contentPages');

    const res = cP(contentPage, contentPages);

    return res;
  };
  const checkContentPagesError = (data, extraProps) => {
    const { checkAll } = validateContentImgList();
    const contentPages = get(data, 'contentPages') || [];
    const countError = checkPagesCountError(data, extraProps);
    const allError = checkAll(contentPages, extraProps);
    return handleOnMergeResult([countError, allError]);
  };
  const checkAll = (data, extraProps) => {
    return checkContentPagesError(data, extraProps);
  };
  return {
    checkTopSectionDisplayError,
    checkEachContentPageError,
    checkContentPagesError,
    checkAll,
  };
};

const checkResponsiveProductGrid = () => {
  const checkProductToShowSelectError = (productToShow) => {
    if (!productToShow) {
      return handleError([
        getI18nFromGeneral(`general.moduleListError.999990`),
      ]);
    }
  };
  const checkProductsCountError = (data, extraProps) => {
    const productToShow = get(data, 'productToShow');

    const productToShowError = checkProductToShowSelectError(productToShow);
    if (get(productToShowError, 'hasError')) {
      return {
        hasError: false, //还没选的话 ，不知道应该选几个，所以不能报错
      };
    }
    const products = get(data, 'products');
    const numOfList = (products || []).length;
    const correctNumber = responsiveProductTypeDict[productToShow];

    if (correctNumber > numOfList) {
      const errorCode = productExactNumberErr[correctNumber];
      return handleError([
        getI18nFromGeneral(`general.moduleListError.${errorCode}`),
      ]);
    }
  };
  const checkTopSectionDisplayError = (data, extraProps) => {
    return checkProductsCountError(data, extraProps);
  };

  const checkProductsError = (data, extraProps) => {
    return checkProductsCountError(data, extraProps);
  };
  const checkAll = (data, extraProps) => {
    const productToShow = get(data, 'productToShow');
    const selectError = checkProductToShowSelectError(productToShow);
    return handleOnMergeResult([
      selectError,
      checkProductsError(data, extraProps),
    ]);
  };
  return {
    checkProductToShowSelectError,
    checkProductsCountError,
    checkTopSectionDisplayError,
    checkProductsError,
    checkAll,
  };
};

const checkResponsiveContentGrid = () => {
  const checkPagesCountError = (data, extraProps) => {
    //const overflowOption = get(data, 'overflowOption');
    const contentPagesToShow = get(data, 'contentPagesToShow');
    const contentPages = get(data, 'contentPages');
    const numOfList = (contentPages || []).length;
    const correctNumber = responsiveContentPageTypeDict[contentPagesToShow];
    if (
      !handleBreakpointIsWide(extraProps)
      // &&
      // overflowOption === EOverflowOption.Carousel
    ) {
      // if (correctNumber > numOfList) {
      //   const errorCode = contentPageNumberErr[correctNumber];
      //   return handleError([
      //     getI18nFromGeneral(`general.moduleListError.${errorCode}`),
      //   ]);
      // }
    } else {
      if (correctNumber !== numOfList) {
        const errorCode = contentPageExactNumberErr[correctNumber];
        return handleError([
          getI18nFromGeneral(`general.moduleListError.${errorCode}`),
        ]);
      }
    }
  };
  const checkTopSectionDisplayError = (data, extraProps) => {
    return checkPagesCountError(data, extraProps);
  };
  const checkEachContentPageError = (contentPage, extraProps) => {
    const { checkEachContentPageError } = validateContentImgList();
    const contentPages = get(extraProps, 'contentPages');

    return checkEachContentPageError(contentPage, contentPages);
  };
  const checkContentPagesError = (data, extraProps) => {
    const { checkAll } = validateContentImgList();
    const contentPages = get(data, 'contentPages');
    const countError = checkPagesCountError(data, extraProps);

    return handleOnMergeResult([
      countError,
      checkAll(contentPages, extraProps),
    ]);
  };
  const checkAll = (data, extraProps) => {
    return checkContentPagesError(data, extraProps);
  };
  return {
    checkTopSectionDisplayError,
    checkEachContentPageError,
    checkContentPagesError,
    checkAll,
  };
};

const checkResponsivePosterTab = () => {
  const checkTabTitleError = (title, extraProps) => {
    if (!title) {
      return handleError([
        getI18nFromGeneral(`general.moduleListError.999966`),
      ]);
    }
  };
  const checkEachPosterError = (poster, extraProps) => {
    return validatePosterAndImages(poster, {
      ...(extraProps || {}),
      isPoster: true,
    });
  };
  const checkEachTabError = (tab, extraProps) => {
    const { posters, title } = tab;
    let hasError = false;
    (posters || [])?.forEach((image) => {
      const res = checkEachPosterError(image, extraProps);
      const { hasError: posterError } = res || {};
      if (!hasError) {
        hasError = posterError;
      }
    });
    const res = checkTabTitleError(title, extraProps);
    const { hasError: titleError } = res || {};
    return { hasError: hasError || titleError };
  };
  const checkTabsError = (tabs, extraProps) => {
    let hasError = false;
    tabs.forEach((t) => {
      const res = checkEachTabError(t, extraProps);
      const { hasError: tError } = res || {};
      if (!hasError) {
        hasError = tError;
      }
    });
    return { hasError };
  };
  const checkAll = (data, extraProps) => {
    const { tabs } = data;
    return checkTabsError(tabs || [], extraProps);
  };
  return {
    checkTabTitleError,
    checkEachPosterError,
    checkEachTabError,
    checkTabsError,
    checkAll,
  };
};

const checkResponsiveProductTab = () => {
  const checkTabTitleError = (title, extraProps) => {
    if (!title) {
      return handleError([
        getI18nFromGeneral(`general.moduleListError.999966`),
      ]);
    }
  };
  const checkEachTabCountError = (tab, extraProps) => {
    //validateEachTabCount
    const { productToShow, products } = tab;
    const requiredNum = responsiveProductTypeDict[productToShow];
    return validateEachTabCount(requiredNum, products, 999967, true);
  };

  const checkTabsError = (tabs, extraProps) => {
    let hasError = false;
    tabs.forEach((i) => {
      const { title } = i;
      const titleError = get(checkTabTitleError(title, extraProps), 'hasError');
      const tabError = get(checkEachTabCountError(i, extraProps), 'hasError');
      if (!hasError && (titleError || tabError)) {
        hasError = true;
      }
    });
    return { hasError };
  };
  const checkAll = (data, extraProps) => {
    const tabs = get(data, 'tabs') || [];
    return checkTabsError(tabs, extraProps);
  };
  return {
    checkAll,
    checkTabsError,
    checkEachTabCountError,
    checkTabTitleError,
  };
};

const checkResponsiveContentPageTab = () => {
  const checkTabTitleError = (title, extraProps) => {
    if (!title) {
      return handleError([
        getI18nFromGeneral(`general.moduleListError.999966`),
      ]);
    }
  };
  const checkEachTabPagesCountError = (tab, extraProps) => {
    const contentPagesToShow = get(tab, 'contentPagesToShow');
    const contentPages = get(tab, 'contentPages');
    // const numOfList = (contentPages || []).length;
    const correctNumber = responsiveContentPageTypeDict[contentPagesToShow];
    return validateEachTabCount(correctNumber, contentPages, 999967, false);
  };
  const checkEachContentPageError = (contentPage, extraProps) => {
    const { checkEachContentPageError: ckE } = validateContentImgList();
    const contentPages = get(extraProps, 'contentPages');
    return ckE(contentPage, contentPages);
  };
  const checkEachTabError = (tab, extraProps) => {
    const contentPages = get(tab, 'contentPages', []);
    const title = get(tab, 'title');
    let hasError = false;
    contentPages.forEach((page) => {
      const pageError = get(
        checkEachContentPageError(page, extraProps),
        'hasError',
      );
      if (!hasError) {
        hasError = pageError;
      }
    });
    const countError = get(
      checkEachTabPagesCountError(tab, extraProps),
      'hasError',
    );
    const titleError = get(checkTabTitleError(title, extraProps), 'hasError');
    return { hasError: hasError || titleError || countError };
  };
  const checkTabsError = (tabs, extraProps) => {
    let hasError = false;
    tabs.forEach((tab) => {
      const { hasError: e } = checkEachTabError(tab, extraProps);
      if (!hasError && e) {
        hasError = e;
      }
    });
    return { hasError };
  };
  const checkAll = (data, extraProps) => {
    const tabs = get(data, 'tabs') || [];
    return checkTabsError(tabs, extraProps);
  };
  return {
    checkTabTitleError,
    checkEachTabPagesCountError,
    checkEachContentPageError,
    checkEachTabError,
    checkTabsError,
    checkAll,
  };
};

const checkResponsiveText = () => {
  const checkContentText = (text, extraProps) => {
    if (!text) {
      return handleError([
        getI18nFromGeneral(`general.moduleListError.999999`),
      ]);
    }
  };
  const checkContentTextBoxWidth = (textBoxWidth, extraProps) => {
    if (!textBoxWidth) {
      return handleError([
        getI18nFromGeneral(`general.moduleListError.999978`),
      ]);
    }
  };

  const checkModuleStyleTopPadding = (topPadding, extraProps) => {
    // if (!topPadding) {
    //   return handleError([
    //     getI18nFromGeneral(`general.moduleListError.999978`),
    //   ]);
    // }
  };
  const checkModuleStyleBottomPadding = (bottomPadding, extraProps) => {
    if (!bottomPadding) {
      return handleError([
        getI18nFromGeneral(`general.moduleListError.999978`),
      ]);
    }
  };

  const checkTopSectionDisplayError = (data, extraProps) => {
    return checkContentText(get(data, 'content.text'), extraProps);
    //return checkProductsCountError(data, extraProps);
  };
  const checkAll = (data, extraProps) => {
    const text = get(data, 'content.text');
    const textBoxWidth = get(data, 'content.textBoxWidth');
    const bottomPadding = get(data, 'moduleStyle.bottomPadding');
    const topPadding = get(data, 'moduleStyle.topPadding');

    return {
      hasError:
        get(checkContentText(text, extraProps), 'hasError') ||
        get(checkContentTextBoxWidth(textBoxWidth, extraProps), 'hasError') ||
        get(
          checkModuleStyleBottomPadding(bottomPadding, extraProps),
          'hasError',
        ) ||
        get(checkModuleStyleTopPadding(topPadding, extraProps), 'hasError'),
    };
  };
  return {
    checkContentText,
    checkContentTextBoxWidth,
    checkModuleStyleTopPadding,
    checkModuleStyleBottomPadding,
    checkTopSectionDisplayError,
    checkAll,
  };
};

const checkModule = (module) => {
  const dic = {
    [EnumModuleType.ResponsiveProductCarousel]: checkResponsiveProductCarousel,
    [EnumModuleType.ResponsiveImageCarousel]: checkResponsiveImageCarousel,
    [EnumModuleType.ResponsiveContentCarousel]: checkResponsiveContentCarousel,
    [EnumModuleType.ResponsiveSubscription]: checkResponsiveSubscription,
    [EnumModuleType.ResponsivePoster]: checkResponsivePoster,
    [EnumModuleType.ResponsiveProductGrid]: checkResponsiveProductGrid,
    [EnumModuleType.ResponsiveContentGrid]: checkResponsiveContentGrid,
    [EnumModuleType.ResponsiveText]: checkResponsiveText,
    [EnumModuleType.ResponsivePosterTab]: checkResponsivePosterTab,
    [EnumModuleType.ResponsiveProductTab]: checkResponsiveProductTab,
    [EnumModuleType.ResponsiveContentTab]: checkResponsiveContentPageTab,
    //generateResponsivePoster //
  };
  return dic[module];
};

export {
  checkModule,
  checkResponsiveContentCarousel,
  checkResponsiveContentGrid,
  checkResponsiveContentPageTab,
  checkResponsiveImageCarousel,
  checkResponsivePoster,
  checkResponsivePosterTab,
  checkResponsiveProductCarousel,
  checkResponsiveProductGrid,
  checkResponsiveProductTab,
  checkResponsiveSubscription,
  checkResponsiveText,
  responsivePosterTypeDict,
  validateButtonLayer,
  validateCarouselSetting,
  validateContentImgList,
  validateIframeLink,
  validateImageLayer,
  validateLayerType,
  validatePosterCarouselSetting,
};
